import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthLayout from "../layout/AuthLayout";

const Signup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/onboarding/company");
  };

  return (
    <AuthLayout showSidebar currentStep={0}>
      <div className="w-full max-w-lg">
        <h1 className="text-3xl font-bold mb-2">
          Welcome to <span className="text-purple-accent">Genzi</span>
        </h1>
        <p className="text-gray-400 mb-8">
          Let's set up your company workspace.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium mb-2">Name</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              className="w-full px-4 py-3 bg-dark-secondary border border-gray-700 rounded-lg focus:outline-none focus:border-purple-accent"
              placeholder="John Doe"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Email</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              className="w-full px-4 py-3 bg-dark-secondary border border-gray-700 rounded-lg focus:outline-none focus:border-purple-accent"
              placeholder="Enter your email"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Password</label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              className="w-full px-4 py-3 bg-dark-secondary border border-gray-700 rounded-lg focus:outline-none focus:border-purple-accent"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            className="w-full py-3 bg-purple-accent hover:bg-purple-hover rounded-lg font-medium transition-colors"
          >
            Sign up
          </button>

          <button
            type="button"
            className="w-full py-3 bg-dark-secondary border border-gray-700 rounded-lg font-medium flex items-center justify-center gap-2 hover:bg-gray-800 transition-colors"
          >
            <img
              src="https://www.google.com/favicon.ico"
              alt="Google"
              className="w-5 h-5"
            />
            Sign up with Google
          </button>

          <p className="text-center text-sm text-gray-400">
            Already have an account?{" "}
            <Link to="/login" className="text-purple-accent hover:underline">
              Log in
            </Link>
          </p>
        </form>
      </div>
    </AuthLayout>
  );
};

export default Signup;
